<template>
  <div class="cp-set-shop-address main">
    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-map-marker-alt icon" />Address
        <!-- <span class="is-pulled-right">{{ business.country }}</span> -->
      </p>
      <div style="margin-top: 10px">
        <textarea class="textarea" v-model="address" rows="3" />
      </div>
      <div class="save-wrapper">
        <p v-if="updatingAddress" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveAddress">Save</p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-globe-asia icon" />Region</p>
      <p class="value">
        {{ $t(`country.${business.country}`) }}
        <span class="hint link is-pulled-right" @click="changeRegion">
          Change
        </span>
      </p>
    </div>

    <div class="divider" />

    <div class="map-wrapper">
      <div :id="mapID" />
    </div>

    <div class="edit-map">
      <span class="button has-text-success" @click="editLocation"> Edit </span>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus.js";
import L from "leaflet";
import "leaflet.awesome-markers";

export default {
  name: "CPSetAddress",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      mapID: "commerce-page-set-address-map",
      addressCallback: "CP_SET_ADDRESS_CALLBACK",
      address: null,
      updatingAddress: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    languages() {
      return this.commerce.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    coords() {
      return { lat: this.business.lat, lng: this.business.lon };
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    this.address = this.business.address;
    this.initMap();
    EventBus.$on(this.addressCallback, (data) => {
      console.log(this.addressCallback, data);
      this.saveCoords(data.lat, data.lon);
      if (!this.address) {
        this.address = data.address;
        this.saveAddress();
      }
      // this.address.lat = data.lat;
      // this.address.lon = data.lon;
      // this.address.name = data.name;
      // this.address.address = data.address;
      // this.forceUpdate();
    });
  },
  beforeDestroy() {
    EventBus.$off(this.addressCallback);
  },
  methods: {
    editLocation() {
      // openSetAddressModal() {
      EventBus.$emit("SET_ADDRESS_MODAL", this.addressCallback);
    },
    changeRegion() {
      var msg = `Please contact TUK Support<br>if you'd like to change region.`;
      this.infoToast(msg, "top", 10000);
    },
    saveCoords(lat, lon) {
      // could check the country of the coords too
      if (!lat || !lon) {
        this.errorToast("Invalid coordinates");
        return;
      }
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          lat: lat,
          lon: lon,
        })
        .then(() => {
          this.successToast("Updated coordinates!");
          this.business.lat = lat;
          this.business.lon = lon;
          this.updateMarkerLocation();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    saveAddress() {
      if (!this.address || this.address.length < 5) {
        this.errorToast("Enter a valid address");
        return;
      }
      this.updatingAddress = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          address: this.address,
        })
        .then(() => {
          this.successToast("Updated address!");
          this.business.address = this.address;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingAddress = false));
    },
    updateMarkerLocation() {
      this.map.panTo(this.coords); // setView, flyTo
      this.marker.setLatLng(this.coords);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles");
      var mapOpts = { attributionControl: false };
      this.map = L.map(this.mapID, mapOpts).setView(this.coords, 17); // set zoom level 17
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        maxZoom: 19,
      }).addTo(this.map);
      this.map.invalidateSize();

      var iconOpts = { icon: "store-alt", markerColor: "blue" };
      var icon = L.AwesomeMarkers.icon(iconOpts);
      this.marker = L.marker(this.coords, { icon: icon }).addTo(this.map);
      this.marker.bindPopup("Shop Location", { closeButton: false });
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
  overflow: hidden;
  max-width: 600px;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  font-size: 0.8em;
  font-weight: 500;
}

.map-wrapper {
  position: relative;
  height: calc(100vh - 334px);
  padding: 4px 0;
  background-color: white;
  z-index: 1;
}

#commerce-page-set-address-map {
  height: 100%;
  position: relative;
  border-radius: 5px;
}
.edit-map {
  position: absolute;
  bottom: 0;
  width: 100vw;
  max-width: 600px;
  padding: 10px;
  z-index: 3;
}
.edit-map .button {
  float: right;
}
/* .edit-map-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 3;
} */
</style>
